import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// --- Interfaces ---
import type { IStore, IStores } from '@interfaces/store';

export interface IStoresState extends IStores {}

export const INITIAL_STATE: IStoresState = {
	metadata: {
		page: 0,
		pageLimit: 0,
		count: 0,
	},
	result: [],
};

@Injectable({
	providedIn: 'root',
})
export class StoresStore {
	private _storesState = new BehaviorSubject<IStoresState>(INITIAL_STATE);
	readonly storesState$ = this._storesState.asObservable();

	constructor() {}

	updateStores(stores: IStoresState) {
		const state = this._storesState.value;

		const data = {
			...state,
			...stores,
		};

		this._storesState.next(data);

		return this._storesState.asObservable();
	}

	updateStore(store: IStore) {
		const state = this._storesState.value;

		const storeIndex = state.result.findIndex(({ id }) => id === store.id);

		if (storeIndex >= 0) {
			state.result[storeIndex] = { ...state.result[storeIndex], ...store };
		} else {
			state.result.push(store);
		}

		const data = state;

		this._storesState.next(data);

		return this._storesState.asObservable();
	}

	deleteStore(store: IStore) {
		const state = this._storesState.value;

		const storeIndex = state.result.findIndex(({ id }) => id === store.id);

		state.result.splice(storeIndex, 1);

		const data = state;

		this._storesState.next(data);

		return this._storesState.asObservable();
	}
}
